<template>
    <div class="container-fluid" style="background-color: white">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form  class="form-inline my-2 my-lg-0">
                    <multiselect
                            v-model="search.employee"
                            class="form-control border-0"
                            :options="employeeAll"
                            select-label=""
                            selectedLabel=""
                            deselectLabel=""
                            placeholder="เลือกพนักงาน"
                            :customLabel="employeeLabel"
                            track-by="id">
                    </multiselect>
                    <multiselect
                        v-model="search.department"
                        class="form-control border-0"
                        :options="optionDepartment"
                        select-label=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="เลือกแผนก"
                        label="department_name"
                        track-by="id">
                    </multiselect>
                    &nbsp;
                    <date-picker
                            v-model="search.date"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            :not-after="currentDate"
                            range
                            placeholder="วันที่อัพเดต" confirm>
                    </date-picker>
                    &nbsp;&nbsp;&nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchScanEmployee(1)"
                            type="button">
                        <icon name="search"></icon> ค้นหา
                    </button>
                    &nbsp; &nbsp;
                    <button type="button"
                            @click="scanEmployeePDF"
                            class="btn btn-primary">
                        <icon name="print"></icon>
                        พิมพ์รายการเวลาการทำงาน
                    </button>
                    &nbsp;&nbsp;
                    <button class="btn btn-warning my-2 my-sm-0"
                            @click="showModalAddWorkTime"
                            type="button">
                        <icon name="plus"></icon>
                        นำเข้าเวลาการทำงาน
                    </button>&nbsp;&nbsp;

                </form>
            </div>
        </nav>

        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">รหัสพนักงาน</th>
                    <th scope="col">ชื่อพนักงาน</th>
                    <th scope="col">เวลา</th>
                    <template>
                        <th scope="col">แก้ไข / ลบ</th>
                    </template>

                </tr>
                </thead>
                <tbody>
                <tr v-for="data in scan_employee">
                    <td>{{data.employee_code}}</td>
                    <td>{{data.employee_name}}</td>
                    <td>
                        <template v-if="data.time_scan">
                            {{data.time_scan | moment("DD/MM/YYYY , HH:mm:ss") }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <a @click="showEditWorkTimeModal(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp;&nbsp;
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="scan_employee.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getScanEmployee">
            </vue-pagination>
            <br>
        </div>

        <b-modal size="md" hide-header hide-footer ref="import_work_time">
            <div style="text-align: center;">
                <import-work-time-modal @submit="submitImportWorkTimeModal" :optionEmployee="employeeAll">
                </import-work-time-modal>
            </div>
        </b-modal>
        <!--delete modal--->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br />
                <button @click="deleteWorkTime"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button @click="hideDeleteModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal hide-header hide-footer ref="add_work_time">
            <add-time-scan-modal @submit="saveAddImportWork"></add-time-scan-modal>
        </b-modal>
<!--        <pre>{{scan_employee}}</pre>-->
    </div>
</template>

<script>
    import Button from "bootstrap-vue/es/components/button/button";
    import { mapState } from "vuex";
    import VuePagination from "../../components/Pagination";
    import ImportWorkTimeModal from "./Modal/ImportWorkTimeModal";
    import ImportWorkTimePDFModal from "./Modal/ImportWorkTimePDFModal";
    import Multiselect from "vue-multiselect";
    import { domain } from "../../util/Constants";
    import EditWorkTimeModal from "./Modal/EditWorkTimeModal";
    import DatePicker from 'vue2-datepicker';
    import moment from "moment";
    import Loading from "../../components/Utility/Loading";
    import AddTimeScanModal from "./Modal/AddTimeScanModal";

    export default {
        components: {
            AddTimeScanModal,
            Loading,
            EditWorkTimeModal,
            Button,
            VuePagination,
            ImportWorkTimeModal,
            ImportWorkTimePDFModal,
            DatePicker,
            Multiselect
        },
        name: "import-work-time",
        created(){
            this.$store.dispatch("ScanEmployee/setScanEmployee");
            this.getCurrentDate();
            this.getDepartmentAll();
            this.$store.dispatch("ScanEmployee/clearFormData");
            this.$store.dispatch('ScanEmployee/clearSearch');
            this.$store.dispatch("Common/setPosition");
            this.$store.dispatch("Employee/getEmployeeAll").then(res=>{
                this.employeeAll = res;
            });
        },
        computed:{
            ...mapState({
                scan_employee:state=>{
                    return state.ScanEmployee.scan_employee
                },
                dataPaginate:state=>{
                    return state.ScanEmployee.dataPaginate;
                },
                user: state => {
                    return state.Auth.user;
                },
                search:state=>{
                    return state.ScanEmployee.search;
                },
            })
        },
        data() {
            return {
                msg : '',
                status_loading : '',
                employeeAll : [],
                delete_id : "",
                event_submit : false,
                currentDate : "",
                optionDepartment : [],
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        console.log(moment(date).format('DD/MM/'+year));
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            };
        },
        methods:{
            employeeLabel(option){
                return `${option.employee_no} - ${option.name}`
            },
            getCurrentDate(){
                this.currentDate = moment().format("YYYY-MM-DD");
            },
            getScanEmployee(){
                const page = this.dataPaginate.current_page;
                this.showLoadingModal();
                this.msg = 'กรุณารอสักครู่';
                this.status_loading = 1;
                //paginate search
                if(this.event_submit){
                    this.searchScanEmployee(page);
                }
                //paginate get data
                else{
                    this.$store.dispatch("ScanEmployee/setScanEmployee",page).then(()=>{
                        this.hideLoadingModal();
                    })
                }
            },
            getDepartmentAll(){
                this.$store.dispatch("Department/getAllDepartment").then(res=>{
                    this.optionDepartment = res;
                })
            },
            showModalImportWorkTime(){
                this.$refs.import_work_time.show();
            },
            hideModalImportWorkTime(){
                this.$refs.import_work_time.hide();
            },
            showModalAddWorkTime(){
                this.$refs.add_work_time.show();
            },
            hideModalAddWorkTime(){
                this.$refs.add_work_time.hide();
            },
            showModalImportWorkTimePDF(){
                this.$refs.import_work_time_PDF.show();
            },
            hideModalImportWorkTimePDF(){
                this.$refs.import_work_time_PDF.hide();
            },
            showLoadingModal(){
                this.$refs.loading.show();
            },
            hideLoadingModal(){
                this.$refs.loading.hide();
            },
            createWorkTimeModal(){
                this.$store.dispatch("ScanEmployee/clearFormData").then(()=>{
                    this.showModalImportWorkTime();
                })
            },
            showEditWorkTimeModal(id){
                this.$store.dispatch("ScanEmployee/showScanEmployeeById",id).then(()=>{
                    this.showModalImportWorkTime();
                })
            },
            showDeleteModal(id) {
                this.delete_id = id;
                this.$refs.delete_item.show();
            },
            hideDeleteModal() {
                this.$refs.delete_item.hide();
            },
            hideEditWorkTimeModal(){
                this.$refs.edit_work_time.hide();
            },
            submitImportWorkTimeModal(submitData){
                console.log(submitData);
                if (submitData){
                    this.$store.dispatch("ScanEmployee/updateScanEmployee",{
                        id :submitData.id,
                        data: submitData
                    }).then(()=>{
                        this.$store.dispatch("ScanEmployee/setScanEmployee",1);
                    })
                }
                this.$store.dispatch("ScanEmployee/clearFormData");
                this.hideModalImportWorkTime();
            },
            saveAddImportWork(value){
                console.log(value);
                if(value){
                    this.showLoadingModal();
                    this.status_loading = 1;
                    this.msg = "กำลังบันทึกข้อมูล";
                    this.$store.dispatch("ScanEmployee/createScanEmployee",value).then(()=>{
                        this.status_loading = 2;
                        this.msg = "บันทึกข้อมูลสำเร็จ";
                        this.getScanEmployee();
                    }).catch(err=>{
                        console.log(err);
                        this.status_loading = 3;
                        this.msg = "บันทึกไม่ข้อมูลสำเร็จ";
                    })
                }
                this.hideModalAddWorkTime();
            },
            scanEmployeePDF(){
                let start_date = '';
                let end_date = '';
                let employee_id = this.search.employee ? this.search.employee.employee_no : '';
                if(this.search.date.length > 0 && this.search.date[0]){
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
                }else{
                    this.search.date = [];
                }
                if (start_date && end_date){
                    let data = {
                        department_id : this.search.department ? this.search.department.id : '',
                        start_date,
                        end_date,
                        employee_id,
                        name : this.user.name,
                    }
                    this.status_loading = 1;
                    this.msg = "กำลังดาวโหลดข้อมูล";
                    this.showLoadingModal();
                   this.$store.dispatch("ScanEmployee/printScanEmployeePDF",data).then(url=>{
                       window.open(url,"_blank");
                       this.hideLoadingModal();
                   }).catch(res=>{
                       console.log(res);
                       this.status_loading = 3;
                       this.msg = "ดาวโหลดข้อมูลไม่สำเร็จ";
                       this.hideLoadingModal();
                   });
                }else{
                    alert('กรุณาเลือกวันที่');
                }
            },
            submitEditImportWorkTimePDFModal(submitData){
                if (submitData != 0){
                    console.log(submitData);
                    this.$store.dispatch("ScanEmployee/saveScanEmployee",{
                        id :submitData.id,
                        data: submitData
                    }).then(()=>{
                        if(this.event_submit){
                            this.searchScanEmployee(this.dataPaginate.current_page);
                        }else{
                            this.$store.dispatch("ScanEmployee/setScanEmployee",1);
                        }
                    })
                }
                this.$store.dispatch("ScanEmployee/clearFormData");
                this.hideEditWorkTimeModal();
            },
            deleteWorkTime(){
                this.$store.dispatch("ScanEmployee/deleteScanEmployee",this.delete_id).then(()=>{
                    this.searchScanEmployee(this.dataPaginate.current_page);
                    this.hideDeleteModal();
                })
            },
            searchScanEmployee(page){
                this.event_submit = true;
                let start_date = '';
                let end_date = '';
                let employee_id = '';
                if(this.search.date.length && this.search.date[0]){
                    start_date = moment(this.search.date[0]).format("YYYY-MM-DD")
                    end_date = moment(this.search.date[1]).format("YYYY-MM-DD")
                }
                else{
                    this.search.date = []
                }

                if(this.search.employee){
                    employee_id = this.search.employee.employee_no
                }
                let data = {
                    page,
                    start_date,
                    end_date,
                    employee_id,
                    department_id : this.search.department ? this.search.department.id : '',
                }
                this.showLoadingModal();
                this.msg = 'กรุณารอสักครู่';
                this.status_loading = 1;
                this.$store.dispatch("ScanEmployee/search",data).then(()=>{
                    this.hideLoadingModal();
                })
            }
        }
    }
</script>

<style scoped>

</style>
